export type PropertySource = 'onekey' | 'off-market';
export function get_source() : PropertySource {
  const url: URL = new URL(window.location.href);
  return (url.searchParams.get('source') ?? 'onekey') as PropertySource;
}
